import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { generateCorrelationId, createBaseQueryWithAuthHandling } from "../utils/helpers";

const baseQueryWithCorrelationId = (baseUrl) => {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    credentials: "include",
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");

      const apiKey = process.env.REACT_APP_API_KEY;
      if (apiKey) headers.set("apikey", apiKey);

      const correlationId = generateCorrelationId();
      if (correlationId) {
        headers.set("x-unum-correlation-id", correlationId);
      }

      return headers;
    },
  });

  return createBaseQueryWithAuthHandling(baseQuery);
};

export default baseQueryWithCorrelationId;
